package devxertech.com.pages.industries.devIndustryEdu

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.commons.CommonArrow
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.industries.devIndustryEdu.educationSpotLight.SpotLightEducation
import devxertech.com.pages.industries.devIndustryEdu.futureEdu.IndustryFuture
import devxertech.com.pages.industries.devIndustryEdu.innovativeAudience.InnovativeAudience
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/industry-edu")
@Composable
fun DevIndustryEdu() {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            image =   Res.Image.industry_Header,
            breakpoint = breakpoint,
            headingText = "Educational Software \n" +
                    "Development Services",
            descriptionText = "Fully automated, innovative and result-based"
        )
        CommonArrow("Education")
        IndustryFuture()
        SpotLightEducation(breakpoint, sitePalette)
        MakeYourOwnTeam(breakpoint)
        InnovativeAudience()
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}